/* eslint-disable */

import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { fetchGraphQL } from "../../../services/api-raindrop";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import WaterfallIcon from "../../../ui-components/waterfall-icon/waterfall-icon.tsx";

import { motion } from "framer-motion";
import Image from "../../../ui-components/image/Image.tsx";

import AccountAvatar from "../../../ui-components/account-avatar/account-avatar.tsx";

import RaindropCard, {
  RaindropCardStyle,
} from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo.js";

import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";

import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";

import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";

import { Size } from "../../../logic/enums.ts";

import OrganisationListElement from "../../../ui-components/organisation-list-element/organisation-list-element.tsx";
import WaterfallListElement from "../../../ui-components/waterfall-list-element/waterfall-list-element.tsx";
import StreakDisplay from "../../../ui-components/streak-display/streak-display.tsx";

import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import RaindropInfoBox from "../../../ui-components/raindrop-info-box/raindrop-info-box.tsx";

const CorporateContributionDetail = ({ isCorporate = true }) => {
  if (!isCorporate) {
    return null;
  }
  return (
    <div className="flex flex-col w-full h-full p-4 border gap-2">
      <div
        className={
          "w-full h-full bg-gradient-to-r from-pink-900 to-pink-700 rounded-lg border border-color-dark-border-primary p-6"
        }
      >
        Number 1 in Food and Drink
      </div>

      <div className="w-full h-full bg-slate-800 rounded-lg border border-color-dark-border-primary p-6">
        <div className="font-bold text-3xl">£1,343,23</div>
        <p className="">was donated in the last month</p>
      </div>

      <RaindropCard>
        <OrganisationLogo />
        <div>British Heart Foundation</div>
      </RaindropCard>
    </div>
  );
};

const AccountAwardsComponent = ({
  accountAwardObjects,
  isAccountOwner = false,
  setUserCurrent = (x) => {},
  account = null,
  setAccount = (x) => {},
}) => {
  if (!accountAwardObjects) {
    return null;
  }

  if (accountAwardObjects.length === 0) {
    return null;
  }

  return (
    <RaindropCard>
      <FlexCol>
        <FlexRow>
          <RaindropHeading
            title="Awards"
            isSecondary={true}
            className="w-fit"
          />
        </FlexRow>

        <FlexRow>
          {accountAwardObjects.map((accountAward) => (
            <BadgeBase
              accountAwardId={accountAward.id}
              slug={accountAward.award.slug}
              title={accountAward.award.title}
              isAccountOwner={isAccountOwner}
              setUserCurrent={setUserCurrent}
              account={account}
              setAccount={setAccount}
            />
          ))}
        </FlexRow>
      </FlexCol>
    </RaindropCard>
  );
};

const BadgeBase = ({
  accountAwardId,
  slug,
  title,
  icon = "fas fa-share",
  tailwindBg = "bg-gradient-to-r from-green-400  to-green-600",
  isGhost = false,
  isAccountOwner = true,
  setUserCurrent = (x) => {},
  account,
  setAccount = (x) => {},
}) => {
  switch (slug) {
    case "early-adopter":
      icon = "fas fa-fire-flame-curved";
      tailwindBg = "bg-gradient-to-r from-blue-500 via-purple-500 to-pink-400";
      break;
    case "coffee-machine":
      icon = "fas fa-coffee";
      tailwindBg =
        "bg-gradient-to-r from-orange-200 via-orange-500 to-orange-800";
      break;
    default:
      break;
  }

  const isSelected = account?.accountAwardFeatured?.award?.slug === slug;

  let tailwindOpacity = "opacity-100";
  let tailwindSaturation = "saturate-100";
  let tailwindBorder = "border-transparent";

  if (isGhost) {
    tailwindOpacity = "opacity-50";
    tailwindSaturation = "saturate-0";
  }

  if (isSelected) {
    tailwindBorder =
      "border-color-border-primary dark:border-color-dark-border-primary";
  }

  const onClick = () => {
    // Update locally to avoid delay
    setUserCurrent((prev) => {
      return {
        ...prev,
        account: {
          ...prev.account,
          accountAwardFeatured: isSelected
            ? null
            : {
                award: { slug: slug },
              },
        },
      };
    });
    setAccount((prev) => {
      return {
        ...prev,
        accountAwardFeatured: isSelected
          ? null
          : {
              award: { slug: slug },
            },
      };
    });

    fetchGraphQL(`
      mutation {
        accountAwardToggleFeatured(
          accountAwardId: "${accountAwardId}"
        ) {
          id
          award {
            slug
          }
        }
      }
    `).then((result) => {
      if (result.errors) {
        console.log(result.errors);
        return;
      }

      setUserCurrent((prev) => {
        return {
          ...prev,
          account: {
            ...prev.account,
            accountAwardFeatured: result.data.accountAwardToggleFeatured,
          },
        };
      });
      setAccount((prev) => {
        return {
          ...prev,
          accountAwardFeatured: result.data.accountAwardToggleFeatured,
        };
      });
    });
  };

  return (
    <RaindropClickable
      onClick={onClick}
      additionalClasses={`${tailwindOpacity} ${tailwindSaturation} `}
      isDisabled={!isAccountOwner}
    >
      <FlexCol
        tailwindWidth="w-fit"
        className={`p-2 border-4 rounded-lg  ${tailwindBorder} transition-all`}
      >
        <div className="flex flex-col items-center justify-center  relative sat">
          <i
            className={`fa fa-shield text-8xl scale-100  ${tailwindBg} bg-clip-text text-transparent`}
          />
          <i className="fa fa-shield text-8xl  scale-90 dark:text-color-dark-background-primary text-color-background-primary absolute " />
          <i
            className={`${icon} text-4xl  absolute -rotate-3 ${tailwindBg} bg-clip-text text-transparent`}
          />
        </div>

        {!isGhost && <RaindropTextHeading1>{title}</RaindropTextHeading1>}
      </FlexCol>
    </RaindropClickable>
  );
};

const AccountUserHero = ({
  accountId,
  name,
  username,
  presignedUrl,

  isFollowing,
  setIsFollowing,
  followingCount,
  followersCount,
  isAccountOwner = false,
  isCorporate = true,
}) => {
  const onFollow = () => {
    setIsFollowing(true);
    fetchGraphQL(`
      mutation {
        followCreate(accountId: "${accountId}" ) {
          id
        }
      }
    `)
      .then((result) => {
        if (result.errors) {
          console.error(result.errors);
          setIsFollowing(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsFollowing(false);
      });
  };

  const onUnfollow = () => {
    setIsFollowing(false);
    fetchGraphQL(`
      mutation {
        followDelete(
          accountId: "${accountId}" 
        ) {
          id
        }
      }
    `)
      .then((result) => {
        if (result.errors) {
          console.error("RD-32423", result.errors);
          setIsFollowing(true);
        }
      })
      .catch((error) => {
        console.error("RD-21213", error);
        setIsFollowing(true);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0, translateY: 20 }}
      animate={{ opacity: 1, translateY: 0 }}
      transition={{ duration: 1, type: "spring", bounce: 0.5 }}
      className="flex flex-col  w-full"
    >
      <div className="flex flex-col gap-4 items-center relative">
        <div className="absolute w-full h-40 bg-[#02ADEF]  rounded-xl -z-10 " />
        <div className="h-20" />

        <div className="flex flex-col relative items-center justify-center gap-2">
          <AccountAvatar
            presignedUrl={presignedUrl}
            username={username}
            isHuge={true}
            isCorporate={isCorporate}
          />

          {isAccountOwner && (
            <RaindropButton
              title="Edit"
              style={ButtonStyle.Tertiary}
              to={"/raindrop/account/upload-profile-picture"}
            />
          )}
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col items-center text-center">
            <h2 className="font-bold text-4xl">{name}</h2>
            <h3 className="font-bold text-xl text-color-text-secondary dark:text-color-dark-text-secondary">
              {username}
            </h3>
          </div>

          {isCorporate && (
            <div className="px-3 py-1 bg-slate-600 rounded-full text-sm font-bold bg-gradient-to-r from-pink-800  to-pink-600 border border-color-dark-border-primary">
              Business
            </div>
          )}
        </div>

        {!isAccountOwner && !isFollowing && (
          <RaindropButton
            style={ButtonStyle.Primary}
            title="Follow"
            onClick={onFollow}
          />
        )}
        {!isAccountOwner && isFollowing && (
          <RaindropButton title="Unfollow" onClick={onUnfollow} />
        )}
      </div>
    </motion.div>
  );
};

const WaterfallHeader = ({ username, urlOrganisation, urlUser, title }) => {
  return (
    <div className="flex flex-row w-full items-center gap-4 hover:pr-2 transition-all">
      <WaterfallIcon
        username={username}
        urlOrganisation={urlOrganisation}
        urlUser={urlUser}
      />
      <div className="flex flex-col text-left whitespace-nowrap">
        <h4 className="text-xs font-bold text-color-dark-text-tertiary">
          Waterfall
        </h4>
        <h1 className="font-bold text-lg">{title}</h1>
      </div>

      <i className="fas fa-chevron-right ml-auto text-color-dark-text-secondary" />
    </div>
  );
};

const WaterfallSelection = ({
  urlOrganisation,
  urlUser,
  title,
  posts,
  waterfallId,
  username,
}) => {
  const navigate = useNavigate();
  return (
    <RaindropClickable
      additionalClasses="w-full"
      onClick={() => {
        navigate(`/raindrop/waterfall/${waterfallId}`);
      }}
    >
      <RaindropCard additionalClasses="gap-6">
        <WaterfallHeader
          urlOrganisation={urlOrganisation}
          title={title}
          urlUser={urlUser}
          username={username}
        />

        <FlexRow className="overflow-scroll no-scrollbar">
          {posts.map((post) => (
            <Image
              key={post.id}
              src={post.mediaObjects[0].presignedUrl}
              className="w-28 h-28 aspect-square rounded-md object-cover"
            />
          ))}
        </FlexRow>
      </RaindropCard>
    </RaindropClickable>
  );
};

const SausageRow = ({ sausage }) => {
  const navigate = useNavigate();

  const onClick = () => {
    console.log("sausage", sausage);
    if (sausage?.waterfall) {
      navigate(`/raindrop/waterfall/${sausage.waterfall.id}`);
      return;
    }
    if (sausage?.organisation) {
      navigate(`/raindrop/organisation/${sausage.organisation.id}`);
      return;
    }
  };

  return (
    <RaindropClickable onClick={onClick} additionalClasses="w-full">
      {sausage?.organisation && (
        <OrganisationListElement
          key={sausage.organisation.id}
          id={sausage.organisation.id}
          name={sausage.organisation.name}
          presignedUrl={sausage.organisation.presignedUrlLogo}
          doShowGiveButton={false}
          color={sausage.styleColor}
          doShowColorIndicator={true}
        />
      )}
      {sausage?.waterfall && (
        <WaterfallListElement
          username={sausage.waterfall.account.username}
          urlUser={sausage.waterfall.account.presignedUrl}
          urlOrganisation={sausage.waterfall.organisation.presignedUrlLogo}
          color={sausage.styleColor}
          title={sausage.waterfall.title}
        />
      )}
    </RaindropClickable>
  );
};

const AccountCircleSection = ({
  sausages,
  isPaused = false,
  accountAwardFeaturedSlug = null,
}) => {
  if (!sausages) {
    return null;
  }

  const sausageValues = sausages.map((s) => {
    return {
      id: s.id,
      percentage: s.percentage,
      value: s.percentage,
      selected: false,
      color: s.styleColor,
    };
  });

  return (
    <FlexCol className="">
      <RaindropCircle
        size="SMALL"
        sausageValues={sausageValues}
        isPaused={isPaused}
        accountAwardFeaturedSlug={accountAwardFeaturedSlug}
      />
    </FlexCol>
  );
};

const AccountSupportsCard = ({ sausages, isViewingAsGuest = true }) => {
  if (sausages === null || sausages === undefined || sausages.length === 0) {
    return null;
  }

  if (isViewingAsGuest) {
    return (
      <RaindropCard additionalClasses="relative">
        <RaindropHeading title="Supports" isSecondary={true} />

        <div className="flex flex-col w-full gap-1 blur-md">
          <div className="flex flex-row gap-4 items-center w-full">
            <div className="h-14 aspect-square bg-slate-200 rounded-xl" />
            <RaindropTextHeading1>The Hidden Organisation</RaindropTextHeading1>
          </div>
          <div className="flex flex-row gap-4 items-center w-full">
            <div className="h-14 aspect-square bg-slate-200 rounded-xl" />
            <RaindropTextHeading1>The Hidden Organisation</RaindropTextHeading1>
          </div>
          <div className="flex flex-row gap-4 items-center w-full">
            <div className="h-14 aspect-square bg-slate-200 rounded-xl" />
            <RaindropTextHeading1>The Hidden Organisation</RaindropTextHeading1>
          </div>
        </div>
        <div className="absolute">
          <RaindropButton
            title="Sign up to view"
            style={ButtonStyle.Primary}
            size={Size.Large}
            to="/raindrop/sign-up"
          />
        </div>
      </RaindropCard>
    );
  }

  return (
    <RaindropMotionFadeUp>
      <RaindropCard additionalClasses="flex flex-col gap-4 w-full">
        <RaindropHeading title="Supports" isSecondary={true} />
        <FlexCol className="w-full">
          {sausages.map((sausage) => (
            <SausageRow key={sausage.id} sausage={sausage} />
          ))}
        </FlexCol>
      </RaindropCard>
    </RaindropMotionFadeUp>
  );
};

const FollowingFollowersStreak = ({
  accountId,
  followerCount,
  followingCount,
  streak,
}) => {
  const navigate = useNavigate();

  return (
    <FlexRow className="justify-center py-4" tailwindGap="gap-4">
      <RaindropInfoBox
        title={"Followers"}
        value={followerCount}
        onClick={() => navigate(`/raindrop/account/${accountId}/followers`)}
      />
      <RaindropInfoBox
        title={"Following"}
        value={followingCount}
        onClick={() => navigate(`/raindrop/account/${accountId}/following`)}
      />
      <RaindropInfoBox
        title={"Streak"}
        value={<StreakDisplay size={Size.Small} streak={streak} />}
      />
    </FlexRow>
  );
};

const RaindropAccount = ({ userCurrent, setUserCurrent = (x) => {} }) => {
  const { accountId } = useParams();

  const [account, setAccount] = useState(null);

  const [isFollowing, setIsFollowing] = useState(false);

  const isAccountOwner = userCurrent?.account.id === accountId;

  const isGuest = !userCurrent;

  useEffect(() => {
    fetchGraphQL(`
      query {
        account(id: "${accountId}") {
          id
          presignedUrl
          username
          name
          isFollowing
          followingCount
          followerCount
          accountAwardFeatured {
            award {
              slug
            }
          }
          accountAwardObjects {
            id
            award {
              title
              slug
            }
          }
          streak {
            currentStreak
          }
          accountPlan {
            id
            isPaused
            
            sausages {
              id
              percentage
              styleColor
              organisation {
                id
                presignedUrlLogo
                name
              }
              waterfall {
                id
                title
                account {
                  id
                  presignedUrl
                  }
                organisation {
                  id
                  presignedUrlLogo
                }
              }
            }
          }
          waterfallObjects {
            id
            title
            createdAt
            account {
              id
              presignedUrl
            }
            organisation {
              id
              presignedUrlLogo
            }
            posts {
              id
              mediaObjects {
                id
                presignedUrl
              }
            }
          }
        }
      }
    `)
      .then((result) => {
        setAccount(result.data.account);
        setIsFollowing(result.data.account.isFollowing);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [accountId]);

  if (account === null || account === undefined) {
    return <RaindropLoadingElement />;
  }

  const isCorporate = false;
  // 2025-02-24 TODO:  This is a feature gate, eventually we should pull this from the GraphQL API.

  return (
    <div
      className={"flex flex-col h-full relative px-4  "}
      id={accountId}
      key={accountId}
    >
      <div className="flex flex-col h-full gap-4 overflow-y-scroll pb-24 no-scrollbar pt-6">
        <AccountUserHero
          accountId={accountId}
          username={account.username}
          name={account.name}
          isAccountOwner={isAccountOwner}
          presignedUrl={account.presignedUrl}
          isFollowing={isFollowing}
          setIsFollowing={setIsFollowing}
          followingCount={account.followingCount}
          followersCount={account.followerCount}
          hasEarlyAdopterBadge={account.hasEarlyAdopterBadge}
          isCorporate={isCorporate}
        />
        <CorporateContributionDetail isCorporate={isCorporate} />
        <FollowingFollowersStreak
          accountId={account.id}
          followerCount={account.followerCount}
          followingCount={account.followingCount}
          streak={account.streak?.currentStreak}
        />

        <AccountCircleSection
          accountAwardFeaturedSlug={account?.accountAwardFeatured?.award?.slug}
          sausages={account?.accountPlan?.sausages}
          isPaused={account?.accountPlan?.isPaused}
        />
        <AccountSupportsCard
          sausages={account?.accountPlan?.sausages}
          isViewingAsGuest={isGuest}
        />

        <AccountAwardsComponent
          accountAwardObjects={account?.accountAwardObjects}
          isAccountOwner={isAccountOwner}
          userCurrent={userCurrent}
          setUserCurrent={setUserCurrent}
          account={account}
          setAccount={setAccount}
        />
        {account.waterfallObjects.length > 0 && (
          <div className="flex flex-col w-full gap-4">
            {account.waterfallObjects.map((waterfall, index) => (
              <RaindropMotionFadeUp delay={index * 0.4} key={waterfall.id}>
                <WaterfallSelection
                  key={waterfall.id}
                  title={waterfall.title}
                  posts={waterfall.posts}
                  waterfallId={waterfall.id}
                  urlUser={waterfall.account.presignedUrl}
                  urlOrganisation={waterfall.organisation.presignedUrlLogo}
                  username={waterfall.account.username}
                />
              </RaindropMotionFadeUp>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RaindropAccount;
